import { inject, Service } from '@angular/core';
import { ServicesService } from '../services';

@Service()
export class ResourceStatusEndpointService {
  readonly #service = inject(ServicesService);

  #backendUrl(endpoint: string) {
    return this.#service.vesta(endpoint);
  }

  groupResourceStatus(groupCode: string, arrangementCode: string) {
    return this.#backendUrl(
      `arrangement/${arrangementCode}/resource/status/group/${groupCode}`,
    );
  }

  storeResourceStatus(arrangementCode: string) {
    return this.#backendUrl(`arrangement/${arrangementCode}/resource/status`);
  }
}
